module.exports = __webpack_public_path__ + "img/logo.5083d9e5.png";